import { ToastContainer as Container } from 'react-toastify';
import styled from 'styled-components';
import { ToastContainerStyles } from './styles';

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650332756
 */
export const ToastContainer = styled(Container)`
  ${ToastContainerStyles}
`;
